import {
  Card,
  CardContent,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import useTransmissionReportLog from "../transmission_report_log/useTransmissionReportLog";
import UserProgressAnalyticChart from "./chart/UserProgressAnalyticChart";
import CloseIcon from "@mui/icons-material/Close";
import { setUserTransmissionProgressData } from "app/store/userActivityLog/slice/userActivityLogSlice";
import useTopTransmissionReportLog from "../transmission_report_log/useTopTransmissionProgressReport";
import TopUserTransmission from "../transmission_report_log/TopUserTransmission";
import Loading from "components/common/loading/Loading";

const UserProgressAnalytic = () => {
  const { selectedUser, userTransmissionProgressData, dispatch } =
    useTransmissionReportLog();

  const {
    isFetching,
    useStyles: getStyles,
    getChartOptions,
  } = useTopTransmissionReportLog();

  return (
    <>
      {userTransmissionProgressData?.chartData?.datasets?.length ? (
        <Card
          elevation={0}
          style={{
            border: "1px solid #E0E0E0",
            borderRadius: "4px",
            height: "100%",
          }}
        >
          <CardContent>
            <Grid
              container
              flex={1}
              alignItems="center"
              justifyContent="space-between"
              sx={{ marginBottom: "20px" }}
            >
              <Grid item>
                <Typography
                  variant="h6"
                  style={{ fontSize: "1.125rem", fontWeight: 500 }}
                >
                  User Transmission Progress Chart
                  {selectedUser && ` - ${selectedUser.label}`}
                </Typography>
              </Grid>
              <Grid item>
                <Tooltip
                  title="Hide user transmission progress chart"
                  placement="bottom"
                >
                  <IconButton
                    onClick={() =>
                      dispatch(setUserTransmissionProgressData(null))
                    }
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
            <Grid container style={{ height: "400px", marginTop: "20px" }}>
              <UserProgressAnalyticChart />
            </Grid>
          </CardContent>
        </Card>
      ) : (
        <Card
          elevation={0}
          style={{
            border: "1px solid #E0E0E0",
            borderRadius: "4px",
            height: "100%",
          }}
        >
          <CardContent>
            <Grid container flex={1} spacing={2} direction="column">
              <Grid item>
                <Typography
                  variant="h6"
                  style={{ fontSize: "1.125rem", fontWeight: 500 }}
                >
                  Top User Transmission Progress Chart
                </Typography>
              </Grid>
              <Grid item>
                {isFetching ? (
                  <Loading />
                ) : (
                  <TopUserTransmission
                    getStyles={getStyles}
                    getChartOptions={getChartOptions}
                  />
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        // )
      )}
    </>
  );
};

export default UserProgressAnalytic;
